module.exports = __webpack_public_path__ + "img/chofu_restaurant_off.bf876d0e.svg";